module.exports = __webpack_public_path__ + "img/logo-new-s.e190996d.svg";